<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div
  class="lightbox no-user-select"
  (keydown)="handleKeydown($event)"
  tabindex="0"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd($event)"
>
  <button class="mt-4 mb-0 lightbox-close" (click)="onCloseClick()">
    &times;
  </button>

  <!-- Image Container with Download Button Below -->
  <div class="lightbox-content">
    <div
      *ngIf="loading && showDelayedLoading"
      class="pulse-overlay d-flex justify-content-center align-items-center"
    >
      <ng-lottie
        [options]="animationOptions"
        [styles]="{ width: '100px', height: '100px' }"
      ></ng-lottie>
    </div>

    <img
      [src]="lightboxImage?.imageUrl"
      class="lightbox-img"
      alt="Enlarged Image"
      loading="lazy"
      (load)="onImageLoaded()"
      (error)="onImageError()"
      appDisableRightAndLongpress
    />

    <div class="d-flex justify-content-center align-items-center gap-3 mt-3">
      <button
        *ngIf="showDownloadIcon"
        class="btn btn-theme"
        (click)="downloadImage()"
        title="Download Image"
      >
        <i class="fas fa-download"></i> Download
      </button>
      <button
        *ngIf="(isLoggedIn$ | async) && showDeleteIcon"
        class="btn btn-theme"
        (click)="deleteImage(lightboxImage)"
      >
        <i class="fas fa-trash"></i> Delete
      </button>
      <button
        *ngIf="(isAdmin$ | async) && showAdminDelete"
        class="btn btn-theme"
        (click)="deleteImageByAdmin(lightboxImage)"
      >
        <i class="fas fa-trash"></i>Delete(Admin)
      </button>
      <button
        *ngIf="showShareOption"
        class="btn btn-theme"
        (click)="shareImage(lightboxImage?.id)"
      >
        <i class="fa fa-share-alt"></i> Share
      </button>
    </div>
  </div>

  <button *ngIf="showNavButtons" class="lightbox-prev" (click)="onPrevClick()">
    <img src="icons/arrow-left-trim.svg" style="filter: brightness(0.5)" />
  </button>
  <button *ngIf="showNavButtons" class="lightbox-next" (click)="onNextClick()">
    <img src="icons/arrow-right-trim.svg" style="filter: brightness(0.5)" />
  </button>
</div>
